import { DynamicEntityIndex } from '@reactiveonline/reactive_admin_shared-packages'
import React from 'react'

const invoiceTableHeadings = [
  { key: 'date_issued',    label: 'date_issued'    },
  { key: 'invoice_number', label: 'invoice_number' },
  { key: 'view_invoice',   label: 'view_invoice'   }
]

export default function Invoices({
  invoices, setInvoices, invoicesPath
}) {
  const invoiceItemRenderer = (item, columns) => {
    let cellValue

    return columns.map(column => {
      if (column.label === 'date_issued') {
        cellValue = item.createdAt
      } else if (column.label === 'invoice_number') {
        cellValue = item.invoiceNumber
      } else if (column.label === 'view_invoice') {
        cellValue = (
          <>
            <div className="darken-4 download-invoice">
              <i className='fa-light fa-file-invoice' />
              Download
            </div>
          </>
        )
      }

      return (
        <div key={ column.label } className='item flex-1'>
          { cellValue }
        </div>
      )
    })
  }

  return (
    <>
      <div className="col s12">
        <div className="card">
          <div className="card-content">
            <div className="card-title">Invoices</div>
          </div>
        </div>
      </div>

      <DynamicEntityIndex
        initialItems={ invoices }
        setInitialItems={ setInvoices }
        disableDelete
        disableCustomization
        disableSearch
        entity='invoices'
        tableHeadings={ invoiceTableHeadings }
        itemRenderer={ invoiceItemRenderer }
        itemsPath={ invoicesPath }
        icon='fa-receipt'
        noResourcesTitle={ Support.translations.account.no_invoices }
        listColumns={ invoiceTableHeadings }
        columnTranslations={ ReactiveCore.translations.columns }
        fetchOnStart
        disableUrlUpdates
      />
    </>
  )
}